import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flexcol flexcenter w100 textcenter" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "Vaya, no hemos encontrado nada en tu base de datos.", -1)

import { query } from "@/busData";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {


function resetSearch() {
  document.querySelector<HTMLElement>(".searchQuery")?.focus()
  query.value = ""
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("a", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (resetSearch())),
      class: "textlink"
    }, "Prueba con una búsqueda nueva")
  ]))
}
}

})